import axios from "axios";
import { logout } from "data/controllers/authController";

// Create an Axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

// Add a request interceptor to include the token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["X-Platform-Type"] = "web";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log("error: ", error.response);
    if (error.response && error.response.status === 401 && !error.config.url.endsWith("/logout")) {
      await logout();
    }
    return Promise.reject(error);
  }
);

export default api;
